export default function timeToMs(value) {
	if (!value) return 0;

	const [h, m, s] = value.includes(":") ? value.split(":") : [value, 0, 0];

	return +h * (60000 * 60) + +m * 60000 + (s ? +s * 1000 : 0);
}
